import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { MuteLogo } from '../components/ui/MuteLogo';
import { useTelegram } from '../hooks/useTelegram';
import { useAppDispatch, useAppSelector } from '../store/hooks';
import { loginWithTelegram, fetchMe } from '../store/slices/authSlice';
import { getAccessToken, clearTokens } from '../api/client';
export function LandingPage() {
    const navigate = useNavigate();
    const { initData, user: tgUser } = useTelegram();
    const dispatch = useAppDispatch();
    const { user, loading } = useAppSelector((s) => s.auth);
    const [restoring, setRestoring] = useState(() => !!getAccessToken());
    const [minTimePassed, setMinTimePassed] = useState(false);
    // Minimum 3s splash display
    useEffect(() => {
        const timer = setTimeout(() => setMinTimePassed(true), 3000);
        return () => clearTimeout(timer);
    }, []);
    // Auto-login: restore session or login via Telegram
    useEffect(() => {
        if (user)
            return;
        const token = getAccessToken();
        if (token) {
            setRestoring(true);
            dispatch(fetchMe())
                .unwrap()
                .then((fetched) => {
                if (tgUser && String(tgUser.id) !== String(fetched.telegramId)) {
                    clearTokens();
                    if (initData)
                        dispatch(loginWithTelegram(initData));
                }
            })
                .catch(() => {
                clearTokens();
                if (initData)
                    dispatch(loginWithTelegram(initData));
            })
                .finally(() => setRestoring(false));
        }
        else if (initData) {
            dispatch(loginWithTelegram(initData));
        }
        else {
            setRestoring(false);
        }
    }, [initData]);
    // Redirect after successful login (gated by splash minimum time)
    useEffect(() => {
        if (!user || !minTimePassed)
            return;
        if (user.isProfileComplete && user.cityId) {
            navigate('/feed', { replace: true });
        }
        else if (user.cityId && !user.isProfileComplete) {
            navigate('/onboarding', { replace: true });
        }
        else {
            navigate('/onboarding-intro', { replace: true });
        }
    }, [user, minTimePassed]);
    // Splash screen — always shown (auto-login happens in background)
    return (_jsxs("div", { className: "splash-screen", style: {
            position: 'absolute', inset: 0, display: 'flex',
            alignItems: 'center', justifyContent: 'center',
            background: '#0A0A0A', overflow: 'hidden',
        }, children: [_jsx("div", { style: {
                    position: 'absolute', top: '50%', left: '50%',
                    width: 300, height: 300,
                    transform: 'translate(-50%, -50%) scale(0)',
                    borderRadius: '50%',
                    background: 'radial-gradient(circle, rgba(236,72,153,.25) 0%, transparent 70%)',
                    animation: 'splashGlowIn 1.2s ease-out .3s forwards',
                } }), _jsx("div", { style: {
                    position: 'absolute', top: '50%', left: '50%',
                    width: 400, height: 400,
                    transform: 'translate(-50%, -50%)',
                    borderRadius: '50%',
                    background: 'radial-gradient(circle, rgba(236,72,153,.5) 0%, transparent 50%)',
                    opacity: 0,
                    animation: 'splashFlashPulse .6s ease-out .8s forwards',
                    pointerEvents: 'none',
                } }), _jsxs("div", { style: { position: 'relative', zIndex: 1, display: 'flex', flexDirection: 'column', alignItems: 'center' }, children: [_jsx(MuteLogo, { size: 200 }), _jsx("p", { className: "splash-title", children: "MUTE" })] })] }));
}
